module.exports = __webpack_public_path__ + "img/ticket.d50cd1bd.svg";